import { Text } from '@thanx/uikit/text'
import React from 'react'
import { Col } from 'react-bootstrap-five'

interface GameFeatureCardProps {
  imageSrc: string
  imageAlt: string
  title: string
  backgroundColor: string
  className?: string
}

const GameFeatureCard = ({
  imageSrc,
  imageAlt,
  title,
  backgroundColor,
  className = '',
}: GameFeatureCardProps) => {
  return (
    <Col md={4} className={`mb-m mb-md-0 ${className}`}>
      <div
        className="h-100 p-l"
        style={{ backgroundColor, borderRadius: '4px' }}
      >
        <div className="mb-l text-center">
          <img
            src={imageSrc}
            alt={imageAlt}
            style={{
              width: '100%',
              height: 'auto',
              maxWidth: '400px',
            }}
          />
        </div>
        <Text.Header4 className="text-center">{title}</Text.Header4>
      </div>
    </Col>
  )
}

export default GameFeatureCard
